export const environment = {
  isIntranet: 'false',
  disableRouteGuards: 'false',
  production: false,
  ENV_ACTIVE_PROFILE: 'customIDP',
  ON_CUSTOMIDP: 'customIDP',
  DefaultCountry: 'SGP',
  RESOURCE_SERVER_URL: 'https://pruworks.prudential.co.id/home',
  isCloudEnv: 'false',
  version: '1.1.8',
  
  // Group PLAID
  BRAND_LANDING_URL: 'https://pruworks.prudential.co.id/',
  
  // PnC Service
  USER_SERVICE: 'https://pruworks.prudential.co.id/life/userrole-service/users', //API-USERROLE
  QUOTE_SERVICE: 'https://pruworks.prudential.co.id/pnc/quotes',
  API_ROLE_PNC_SERVER_URL: 'https://pruworks.prudential.co.id/life/userrole-service/users', //API-USERROLE
  // Pnc anonymous user
  userName: '',
  password: '',

  //LIFE anonymous user
  userNameLife: '',
  passwordLife: '',

  // domain
  WEB_DOMAIN: '.pruworks.prudential.co.id',
  PATH: '/pnc-claims-portal',

  // API CONFIG URL PNC
  API_LOB_ONPREM_PNC: 'https://pruworks.prudential.co.id/life/userrole-service/roles/',
  CUSTOMER_SELF_CONTEXT_PATH: '/pnc-self-portal',
  // Pnc context path
  CONTEXT_PATH: '/pnc-customer-portal',
  API_USER_SERVER_URL: 'https://pruworks.prudential.co.id/life/customer-api', //API-CUSTOMERPORTAL
  API_ROLE_SERVER_URL: 'https://pruworks.prudential.co.id/life/userrole-service/roles/user', //API-USERROLE
  API_LOB_PERSON_SERVER_URL: 'https://pruworks.prudential.co.id/life/userrole-service/roles/', //API-USERROLE
  API_LOGIN_SERVER_URL: 'https://pruworks.prudential.co.id/life/userrole-service/', //API-USERROLE
  API_SERVER_URL: 'https://pruworks.prudential.co.id/life/customer-api', //API-CUSTOMERPORTAL
  API_CONFIG_URL: 'https://pruworks.prudential.co.id/group-common', //COMMON-CONFIGURATION
  API_DMS_SERVER_URL: 'https://pruworks.prudential.co.id/life/dms', //API-DMS
  API_SERVER_USER: 'https://pruworks.prudential.co.id/life/userrole-service', //API-USERROLE
  API_CONFIG_COMMON: 'https://pruworks.prudential.co.id/group-common/configuration/',
  EnterpriseLinkKey: 'EnterpriseLink',

  //GROUP Service
  API_GROUP_USERROLE_SERVICE: 'https://pruworks.prudential.co.id/life/userrole-service', //API-USERROLE
  //redirect URI for all portals
  localOrigin: 'https://pruworks.prudential.co.id',
  onlineClaim: 'https://pruworks.prudential.co.id',
  N_GS: 'https://pruworks.prudential.co.id',
  N_GU: 'https://pruworks.prudential.co.id',
  L_CS: 'https://pruworks.prudential.co.id',
  L_SI: 'https://pruworks.prudential.co.id',
  L_UW: 'https://pruworks.prudential.co.id',
  L_MP: 'https://pruworks.prudential.co.id',
  L_LM: 'https://pruworks.prudential.co.id',
  L_DM: 'https://pruworks.prudential.co.id',
  L_PS: 'https://pruworks.prudential.co.id',
  L_CR: 'https://pruworks.prudential.co.id',
  L_CO: 'https://pruworks.prudential.co.id',
  L_DPS: 'https://pruworks.prudential.co.id',
  A_AD: 'https://pruworks.prudential.co.id',
  L_DS: 'https://pruworks.prudential.co.id',
  P_SI: 'https://pruworks.prudential.co.id',
  P_CO: 'https://pruworks.prudential.co.id',
  P_CS: 'https://pruworks.prudential.co.id',
  P_CC: 'https://pruworks.prudential.co.id',
  P_SV: 'https://pruworks.prudential.co.id',
  P_GP: 'https://pruworks.prudential.co.id',
  P_SB: 'https://pruworks.prudential.co.id',
  G_HR: 'https://pruworks.prudential.co.id',
  P_UW: 'https://pruworks.prudential.co.id',
  G_FI: 'https://pruworks.prudential.co.id',
  G_ME: 'https://pruworks.prudential.co.id',
  G_PB: 'https://pruworks.prudential.co.id',
  G_PA: 'https://pruworks.prudential.co.id',
  G_PO: 'https://pruworks.prudential.co.id',
  G_PH: 'https://pruworks.prudential.co.id',
  G_PC: 'https://pruworks.prudential.co.id',
  G_PP: 'https://pruworks.prudential.co.id',
  G_PT: 'https://pruworks.prudential.co.id',
  G_IU: 'https://pruworks.prudential.co.id',
  G_OP: 'https://pruworks.prudential.co.id',
  G_SL: 'https://pruworks.prudential.co.id',
  G_IP: 'https://pruworks.prudential.co.id',
  G_IC: 'https://pruworks.prudential.co.id',
  G_IA: 'https://pruworks.prudential.co.id',
  G_IF: 'https://pruworks.prudential.co.id',
  G_IR: 'https://pruworks.prudential.co.id',
  G_DH: 'https://pruworks.prudential.co.id',
  L_CL: 'https://pruworks.prudential.co.id',
  L_CF: 'https://pruworks.prudential.co.id',


  // ON_PREMISES
  ON_PREMISES: 'onPremise',

  // ON_PREMISES_CAS
  ON_PREMISES_CAS: 'CAS',

  // ON_CLOUD
  ON_CLOUD: 'cloud',

  //Date Format
  DATE_FORMAT: 'DD/MM/YYYY',
  DATE_FORMAT1: 'YYYY-MM-DD',

  // Employee Auth API
  EMPLOYEE_AUTH: {
    baseUrl: 'https://pruworks.prudential.co.id',
    loginPath: '/customidp/employee/login',
    signupPath: '/customidp/employee/signup',
    forgotPasswordPath: '/customidp/employee/forgot-password'
  },
  
    // Employer Auth API
  EMPLOYER_AUTH: {
    baseUrl: 'https://pruworks.prudential.co.id',
    loginPath: '/customidp/employee/login',
    signupPath: '/customidp/employee/signup',
    forgotPasswordPath: '/customidp/employee/forgot-password'
  },
  
  
  // Show Portal 2.0
  PORTAL_2_TOGGLE: {
    salesforce: 'true',
    employer: 'true',
    employee: 'true',
  },
  
  // Sales Auth API
  SALESFORCE_AUTH: {
    baseUrl: 'https://pruworks.prudential.co.id',
    saleLoginPath: '/customidp/sale/login',
    userLoginPath: '/customidp/uw/login',
    salesforceRedirectUrl: 'https://pruworks.prudential.co.id/GroupSales/proposal/proposal-dashboard',
    underwritingRedirectUrl: 'https://intra.lb1-pruidlife-prd-az1-i7e7oy.pru.intranet.asia/GroupUnderwriting/proposal/proposal-dashboard',
    adminPortalRedirectUrl: 'https://intra.lb1-pruidlife-prd-az1-i7e7oy.pru.intranet.asia/UserManagement',
    extLoginUrl: '/home/customidp/salesforce/login',
  },

  // Homelanding redirect
  LandingPortalLoginUrl: {
    Employee: 'https://pruworks.prudential.co.id/home/employee/account/login',
    Employer: 'https://pruworks.prudential.co.id/home/employer/account/login',
    },
  ON_CUSTOMIDP_TERMS_CONDITIONS_URL: {
    EMPLOYEE: 'https://pruworks.prudential.co.id/home/terms-and-conditions-employee-id',
    EMPLOYER: 'https://pruworks.prudential.co.id/home/terms-and-conditions-employer-id',
  },

  // callback urls
  PORTAL_URLS: {
    salesforce: 'https://pruworks.prudential.co.id/salesforce',
    employer: 'https://pruworks.prudential.co.id/employer',
    employee: 'https://pruworks.prudential.co.id/employee',
  },


  
  // CustomerIDP profile
  ON_CUSTOMIDP_Auth: {
    ClientId: '3m751nfhlg4cph831e23e8gsj4',
    //LoginUrl: '${SOE_CUSTOMER_IDP_URL}/group/customidp/oauth2/authorize',
    LoginUrl: 'https://pruworks.prudential.co.id/customidp/user/login', //customIDP url customized for PLAI
    TokenUrl: 'https://pruworks.prudential.co.id/oauth2/token',
    redirectUri:
      window.location.origin + '/GroupSales/proposal/proposal-dashboard',
    logoutURL: 'https://pruworks.prudential.co.id/logout',
    landingLogout: 'https://pruworks.prudential.co.id/customidp/user-persona',
    response_type: 'code',
    scope: 'read',
    x_api_key: '',
    employerPortal: 'https://pruworks.prudential.co.id/CustomerPortal/home'
  },

  // IDP-Configuration profile
  IDP: {
    issuer: '/oauth2/default',
    redirectUri: window.location.origin + '/web',
    clientId: '',
    disablePKCE: false,
    responseType: 'code'
  },

  //CAS profile
  OAUTH2_CAS: {
    ClientId: '',
    LoginUrl: '/oauth2.0/authorize',
    TokenUrl: '/oauth2.0/accessToken',
    CallbackUrl: window.location.origin + '/home/el-web',
    logoutURL: '/logout',
    landingLogout: 'https://pruworks.prudential.co.id/home/user-persona'
  },
  
  PNC_DEFAULT_CUSTOMER_CONFIGURATION: {
    SERVER_URL: '',
    client_id: '',
    redirectUri: window.location.origin + '/home/el-web',
    scope: 'openid',
    response_type: 'code',
    x_api_key: ''
  },

  COGNITO: {
    CAS_SERVER_URL: '/logout',
    ClientId: '',
    LoginUrl: '/oauth2/authorize',
    TokenUrl: '/oauth2/token',
    UserInfo: '/oauth2/userInfo',
    SERVER_URL: '/logout',
    logoutURL: '/logout',
    landingLogout: 'https://pruworks.prudential.co.id/home/EL-LandingPage',
    CallbackUrl: window.location.origin + '/home/el-web',
    x_api_key: '',
    identity_provider: ''
  },
};
